import { Alert } from "@mui/material";
import { useTranslation } from "react-i18next";

import { CopyButton } from "~/components/Buttons";
import logger from "~/helpers/logger";
import m365Mailbox from "~/helpers/m365Mailbox";
import snackMessages from "~/helpers/snackMessages";
import { useSnacks } from "~/providers/SnackProvider";
import { useGetM365MailboxAdminConsentUrlQuery } from "~/services/endpoints/apiEndpoints";

const COPY_ACTION = "copying the admin approval link";

const OutlookAdminApprovalNotice = () => {
	const { t } = useTranslation("common");
	const [openSnack] = useSnacks();
	const { data } = useGetM365MailboxAdminConsentUrlQuery({ redirectUri: m365Mailbox.adminConsentRedirectUri() });
	const adminConsentUrl = data?.m365MailboxAdminConsentUrl;

	const handleCopy = async () => {
		if (!adminConsentUrl) return;
		try {
			await navigator.clipboard.writeText(adminConsentUrl);
			openSnack(t("preferences.linkedEmail.adminApproval.copied"), "success");
		} catch (error) {
			logger.error(snackMessages.actionError(COPY_ACTION), error);
			openSnack(snackMessages.actionError(COPY_ACTION), "error");
		}
	};

	return (
		<Alert
			action={
				<CopyButton color="inherit" disabled={!adminConsentUrl} onClick={handleCopy} size="small" variant="text">
					{t("preferences.linkedEmail.adminApproval.copyLink")}
				</CopyButton>
			}
			severity="info"
		>
			{t("preferences.linkedEmail.adminApproval.notice")}
		</Alert>
	);
};

export default OutlookAdminApprovalNotice;
